import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { FHIRServiceInjectionToken } from './fhir-service.providers';

@Injectable({
  providedIn: 'root',
})
export class FhirGuardService implements CanActivate {
  readonly #fhirService = inject(FHIRServiceInjectionToken);
  readonly #router: Router = inject(Router);
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const client = await this.#fhirService.getClient();
    if (route.queryParams['fhirAuthorizeError'] === 'true' || client) {
      return true;
    }

    this.#router.navigate(['/'], {
      queryParams: route.queryParams,
    });
    return false;
  }
}
